import { Fonoaudiologia as FonoaudiologiaPessoa } from "../../Pessoa/Setor/Fonoaudiologia";

export const Fonoaudiologia = ({ pessoa, setPessoa }) => (
  <>
    <FonoaudiologiaPessoa pessoa={pessoa} setPessoa={setPessoa} />
  </>
);
